import React, { useEffect, useState } from "react";
import svg64 from "../../../../assets/svg/svg64.svg";
import { Table } from "antd";
import { fetchData } from "../../../../features/fetch/fetchSlice";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import CardLoading from "../../../../components/CardLoading";
import VerficationDocsModal from "./VerficationDocsModal";
import useModalToggle from "../../../../custom_hooks/useModalToggle";

function VerifiedReportTable() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const url = "api/v2/getFarmers";
  const urlFarmer = "api/v2/flid/dashboard/mainParams";

  const { loading, data, count, activeObjexpressions } = useSelector(
    (state) => ({
      loading: state.fetch.loading,
      data: state.fetch.data[url] || [],
      count: state.fetch.count[url] || 0,
      activeObjexpressions: state.obj.activeObj["expressions"],
    })
  );

  const { open, handleCancel, handleOpen } = useModalToggle();
  const [prodd, setProdd] = useState("");

  const handleOpenDocs = async () => {
    await handleOpen();
  };

  const handleDisburse = () => {
    navigate("/isp-pay-list");
  };
  const columns = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Item",
      render: (item) => {
        return <div>{item?.fullNames}</div>;
      },
      sorter: (a, b) => a.fullNames.localeCompare(b.fullNames),
    },

    {
      title: "Quantity",
      dataIndex: "email",
      sorter: (a, b) => a.email.localeCompare(b.email),
    },
    {
      title: "Standard Price",
      dataIndex: "phoneNumber",
      sorter: (a, b) => a.phoneNumber.localeCompare(b.phoneNumber),
    },
    {
      title: "New Subtotal",
      dataIndex: "usrNationalId",
      sorter: (a, b) => a.usrNationalId.localeCompare(b.usrNationalId),
    },
    {
      title: "Meet Criteria",
      dataIndex: "usrCountyName",
      render: (item) => {
        return (
          <div>
            {item === "Yes" ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="11"
                height="7"
                viewBox="0 0 11 7"
                fill="none"
              >
                <path
                  d="M10.0915 0.451972L10.0867 0.446075L10.0813 0.440568C9.90076 0.253564 9.61034 0.253146 9.42927 0.439309L4.16201 5.72962L1.58507 3.13469C1.40401 2.94841 1.11351 2.94879 0.932892 3.13584C0.755703 3.31933 0.755703 3.60875 0.932892 3.79224L0.932878 3.79225L0.934851 3.79424L3.58046 6.45832C3.73676 6.61955 3.94983 6.7 4.1473 6.7C4.36196 6.7 4.55963 6.61773 4.71406 6.4584L10.0468 1.10234C10.2436 0.919903 10.2421 0.633904 10.0915 0.451972ZM4.2327 5.80081L4.2317 5.7998C4.23206 5.80015 4.23237 5.80049 4.23269 5.80082L4.2327 5.80081Z"
                  fill="white"
                  stroke="white"
                  stroke-width="0.4"
                />
              </svg>
            ) : (
              <svg
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M20 1.125C9.5625 1.125 1.125 9.5625 1.125 20C1.125 30.4375 9.5625 38.9375 20 38.9375C30.4375 38.9375 38.9375 30.4375 38.9375 20C38.9375 9.5625 30.4375 1.125 20 1.125ZM20 36.125C11.125 36.125 3.9375 28.875 3.9375 20C3.9375 11.125 11.125 3.9375 20 3.9375C28.875 3.9375 36.125 11.1875 36.125 20.0625C36.125 28.875 28.875 36.125 20 36.125Z"
                  fill="#B42318"
                />
                <path
                  d="M25.75 14.1875C25.1875 13.625 24.3125 13.625 23.75 14.1875L20 18L16.1875 14.1875C15.625 13.625 14.75 13.625 14.1875 14.1875C13.625 14.75 13.625 15.625 14.1875 16.1875L18 20L14.1875 23.8125C13.625 24.375 13.625 25.25 14.1875 25.8125C14.4375 26.0625 14.8125 26.25 15.1875 26.25C15.5625 26.25 15.9375 26.125 16.1875 25.8125L20 22L23.8125 25.8125C24.0625 26.0625 24.4375 26.25 24.8125 26.25C25.1875 26.25 25.5625 26.125 25.8125 25.8125C26.375 25.25 26.375 24.375 25.8125 23.8125L22 20L25.8125 16.1875C26.3125 15.625 26.3125 14.75 25.75 14.1875Z"
                  fill="#B42318"
                />
              </svg>
            )}
          </div>
        );
      },
    },
  ];

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  async function fetchTableData(page, size) {
    await dispatch(
      fetchData({
        url: url,
        limit: size ?? pageSize,
        start: page ?? pageIndex,
      })
    );
  }

  useEffect(() => {
    fetchTableData();
  }, []);

  console.log("activeObjexpressions", activeObjexpressions);

  if (loading) return <CardLoading />;
  return (
    <div className="mt-[1rem] border border-[#D6E1F5] py-[2.12rem] px-[.62rem] rounded-[0.75rem]">
      <div className="flex lg:flex-row flex-col lg:items-center justify-between">
        <div className="flex items-start gap-x-[.75rem]">
          <img src={svg64} alt="svg64" />
          <div className="flex flex-col">
            <span className="graph_h1 !text-[#1A1A1A]">
              {activeObjexpressions?.irrigationType}
            </span>
            <span className="font-interSans font-[400] text-[#1A1A1A] text-[.875rem]">
              Meets Criteria: Top Quality assured
            </span>
          </div>
        </div>
        <div className="flex lg:flex-row flex-col lg:items-center gap-x-[.94rem] lg:gap-y-0 gap-y-[.94rem]">
          <span
            className="text-[#1A1A1A] text-[.875rem] font-[400] font-interSans underline cursor-pointer"
            onClick={handleOpenDocs}
          >
            View Docs
          </span>
          <div className="w-[200px]">
            <button onClick={() => handleDisburse()} className="cstm-btn-2">
              <span className="">Record ISP Payment</span>
            </button>
          </div>
        </div>
      </div>

      <div className="mt-[1.81rem]">
        <Table
          rowSelection={false}
          className=" w-full"
          scroll={{
            x: 1200,
          }}
          rowKey={(record) => record?.usrId}
          columns={columns}
          dataSource={[]}
          loading={loading}
          pagination={{
            position: ["bottomRight"],
            current: pageIndex + 1,
            total: count,
            pageSize: pageSize,
            onChange: (page, size) => {
              setPageIndex(page - 1);
              setPageSize(size);
              fetchTableData(page - 1, size);
            },
            showSizeChanger: false,
            hideOnSinglePage: true,
          }}
        />
      </div>

      <VerficationDocsModal
        isModalOpen={open}
        handleCancel={handleCancel}
        handleFetch={fetchTableData}
        prodd={prodd}
      />
    </div>
  );
}

export default VerifiedReportTable;
